export const ARIZONA_MAP_BOUNDS = [
  [-114.9, 31.15],
  [-109.0, 37.1],
];

// These conservative interior bounds keep every generated point in Arizona's
// populated corridor while leaving room to tune the mock-city clusters.
export const ARIZONA_MOCK_BOUNDS = Object.freeze({
  minimumLatitude: 31.75,
  maximumLatitude: 36.75,
  minimumLongitude: -114.55,
  maximumLongitude: -109.2,
});

export const INITIAL_MAP_CENTER = [-111.9, 34.25];
export const INITIAL_MAP_ZOOM = 5.65;
// Keep a statewide view comfortably below the first detail threshold.
export const ARIZONA_FIT_PADDING = 64;

// Match the desktop layout breakpoint in styles.css. Narrow layouts retain the
// original bounds behavior, while wider bounds keep desktop maps from deriving
// a larger effective minimum zoom as their containers grow.
export const HEX_CAMERA_DESKTOP_BREAKPOINT = 760;
export const HEX_DESKTOP_MIN_ZOOM = 5.61;
export const HEX_NARROW_MAX_BOUNDS = Object.freeze([
  Object.freeze([-117.3, 29.8]),
  Object.freeze([-106.7, 38.4]),
]);
export const HEX_DESKTOP_MAX_BOUNDS = Object.freeze([
  Object.freeze([-119, 29.8]),
  Object.freeze([-105, 38.4]),
]);

// Change these values after visual review without changing aggregation code.
export const HEX_ZOOM_THRESHOLDS = Object.freeze({
  resolution4At: 5.75,
  resolution5At: 7.25,
  resolution6At: 9,
  resolution7At: 10,
});

export const HEX_RESOLUTIONS = Object.freeze([3, 4, 5, 6, 7]);
